import * as Yup from 'yup'

export const initialValues = {
  phone: '',
  firstName: '',
  lastName: '',
  email: '',
}

export type FormValuesType = typeof initialValues

export const formSchema = Yup.object({
  firstName: Yup.string().required('First Name required'),
  lastName: Yup.string().required('Last Name required.'),
  phone: Yup.string()
    .nullable()
    .matches(/^\+[1-9]\d{1,14}$/, {
      message: 'Phone must be in international format (e.g., +15555551234)',
      excludeEmptyString: true,
    }),
})
